document.addEventListener('DOMContentLoaded',function(){
  'use strict';
  var hero=document.getElementById('Ar26Hero');
  if(!hero)return;
  var video=hero.querySelector('.ar26-hero__video');
  var toggle=hero.querySelector('[data-ar26-video-toggle]');
  var label=hero.querySelector('[data-ar26-video-toggle-text]');
  if(!video||!toggle||!label)return;
  function setPlaying(playing){
    toggle.setAttribute('aria-pressed',playing?'false':'true');
    toggle.setAttribute('aria-label',playing?'Kaminvideo pausieren':'Kaminvideo abspielen');
    label.textContent=playing?'Ⅱ':'▶';
  }
  var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduceMotion){video.pause();setPlaying(false)}
  else{
    var promise=video.play();
    if(promise&&typeof promise.catch==='function')promise.catch(function(){setPlaying(false)});
  }
  video.addEventListener('error',function(){hero.classList.add('ar26-hero--fallback');toggle.hidden=true});
  toggle.addEventListener('click',function(){
    if(video.paused){var p=video.play();if(p&&p.then)p.then(function(){setPlaying(true)}).catch(function(){setPlaying(false)})}
    else{video.pause();setPlaying(false)}
  });
  // Keep collection filter panels below the hamburger menu.
  var menu=document.querySelector('[data-menu-toggle]');
  if(menu)menu.addEventListener('click',function(){
    document.querySelectorAll('[data-collection-filter-drawer][open]').forEach(function(panel){panel.open=false});
  });
});
